import { useTranslation } from 'react-i18next';
import getOrgById from '../hooks/getOrgById';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRibbon, faHandHoldingHeart, faHandHoldingDollar, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import getCauseByOrg from '../hooks/getCauseByOrg';
import { dateConverter } from '../utils/utcDateConversion';
import getEventsByOrg from '../hooks/getEventsByOrg';
import { app } from '../config';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
import { useNavigate } from 'react-router-dom';
import useFetchTransactionsByOrgDashBoard from '../hooks/fetchTransactions By Org DashBrd';
import { DatePicker, Space } from 'antd';
// import moment from "moment";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import useFetchRecurringPayments from '../hooks/fetchRecurringPayments';
import usefetchTotalAmountforOrgPortal from '../hooks/fetchTotalAmountforOrgPortal';
dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;
const OrgDashboard = () => {
    const date = new Date();
    let dateFormat = 'YYYY-MM-DD';
    const defaultRange = []
    //[dayjs(`${date.getFullYear()}-01-01`, dateFormat), dayjs(`${date.toISOString().split('T')[0]}`, dateFormat)];
  const { t } = useTranslation(['common']);
  const navigate=useNavigate();
  const [donorCount,setDonorCount] = useState(0);
  const [transByCause,setTransByCause]=useState([]);
  const [transByCauseApproved,setTransByCauseApproved]=useState([]);
  // `${date.toISOString().split('T')[0]} 23:59:59`
  const [dateObj, setDateObj] = useState({ dateFrom: null, dateTo: null });
  const [recurrByDate,setRecurringByDate]=useState(0);
  const [recurrByDateApproved,setRecurringByDateApproved]=useState(0);
  const [noRecordFound,setNoRecordFound]=useState(true)
  const [tableDonationAmount,setTableDonationAmount]=useState({})
  const [tableDonationAmountApproved,setTableDonationAmountApproved]=useState({})
  const [dateSearch,setDateSearch]=useState(false);
  let organizationName;
  window.document.title = 'Dashboard';
  const user = JSON.parse(localStorage.getItem('user'));
  const o = getOrgById(user.organizationId);
  const organization = o.response ? o.response.data : [];
  if (o.response) organizationName = organization.organizationName;
  const recurrPaymentResp= useFetchRecurringPayments(user,user.organizationId);
  console.log("recurrPaymentResp: ")
  console.log(recurrPaymentResp)
  let totalRecurring=0;
  totalRecurring=recurrPaymentResp?.response?.data?.totalAmount;
  console.log(totalRecurring);
  // let tr = useFetchTransactionsByOrg(user.organizationId);
  let totalTransResp=usefetchTotalAmountforOrgPortal(user.organizationId);
  console.log("totalTransResp: ")
  console.log(totalTransResp?.response?.data?.totalAmount)
  let totalDonations = 0;
  totalDonations=totalTransResp?.response?.data?.totalAmount
  let tr =  useFetchTransactionsByOrgDashBoard(user.organizationId);
  let transactions = tr.response ? tr.response.data : [];
  const covertedTransObj = dateConverter(transactions, 'donationDate');
  const token=getTokenfromUserObj();
  useEffect(() => {
    const donorsCount=async()=>{
      const user = JSON.parse(localStorage.getItem('user'));
      const donorResp=await axios.get(`${app.URL}/trans/donorcountbyorg/${user.organizationId}`,{headers:{auth:token}});
      donorResp.data?setDonorCount(donorResp.data.data.donorCount):" ";
    }
  donorsCount();

    }, []);
    const onChange = (date, dateString) => {
      console.log(date)
      console.log(date, dateString);
      setDateObj({dateFrom:dateString[0],dateTo:dateString[1]})
    };
  let tableDonationSum=0;
  let tableServiceFeeSum=0;
  let tabletotalRecurringAmount=0;

  let tableDonationSumApproved=0;
  let tableServiceFeeSumApproved=0;
  let tabletotalRecurringAmountApproved=0;
  // totalDonations=totalTransResp?.response?.data?.totalAmount;
  // transactions.forEach((transaction) => {
  //   totalDonations += Number(transaction.amount);
  // });
  let c = getCauseByOrg(user.organizationId);
  let causeCount = c.response ? (c.response.data.length < 10 ? '0' + c.response.data.length : c.response.data.length) : [];

  let donors = donorCount ? donorCount<10  && donorCount!=0 ? '0' + donorCount : donorCount : 0;
  let e=getEventsByOrg(user.organizationId);
  let eventCount = e.response?e.response.data.length:0;
  // orgtranscauseapproved
  useEffect(() => {
    const getTransByOrgCause = async () => {
      console.log('Function Running get Trans');
      console.log(dateObj)
      if(dateObj.dateFrom||dateObj.dateTo){
        setDateSearch(true);
      }
      else {
        setDateSearch(false);
      }
        
      const res = await axios.post(`${app.URL}/trans/orgtranscauseapproved/${user.organizationId}`,dateObj, { headers: { auth: token } });
      const recurringResp = await axios.get(`${app.URL}/recurrpayment/view?organizationId=${user.organizationId}&startDate=${dateObj.dateFrom}&endDate=${dateObj.dateTo}`, { headers: { auth: token } });
      console.log(recurringResp)
      res.data?setTransByCauseApproved(res.data.data):" ";
      // res.data&&res.data.data.length==0?setNoRecordFound(true):setNoRecordFound(false);
      res.data?setRecurringByDateApproved(recurringResp.data.data.totalAmount):0;
      res.data&&res.data.data.forEach((ele)=>{
        tableDonationSumApproved+=Number(ele.totalAmount);
        console.log(tableDonationSumApproved)
        tableServiceFeeSumApproved+=Number(ele.serviceFee);
        console.log(tableServiceFeeSumApproved)
        tabletotalRecurringAmountApproved+=Number(ele.recurringAmount);
      })
      console.log(tabletotalRecurringAmountApproved)
      setTableDonationAmountApproved({tableDonationSumApproved,tableServiceFeeSumApproved,tabletotalRecurringAmountApproved})
    };
    
      getTransByOrgCause()
  }, []);
  console.log(transByCauseApproved)
  console.log(tableDonationAmountApproved);

  useEffect(() => {
    const getTransByOrgCause = async () => {
      console.log('Function Running get Trans');
      console.log(dateObj)
      if(dateObj.dateFrom||dateObj.dateTo){
        setDateSearch(true);
      }
      else {
        setDateSearch(false);
      }
        
      const res = await axios.post(`${app.URL}/trans/orgtranscause/${user.organizationId}`,dateObj, { headers: { auth: token } });
      const recurringResp = await axios.get(`${app.URL}/recurrpayment/view?organizationId=${user.organizationId}&startDate=${dateObj.dateFrom}&endDate=${dateObj.dateTo}`, { headers: { auth: token } });
      console.log(recurringResp)
      res.data?setTransByCause(res.data.data):" ";
      res.data&&res.data.data.length==0?setNoRecordFound(true):setNoRecordFound(false);
      res.data?setRecurringByDate(recurringResp.data.data.totalAmount):0;
      res.data&&res.data.data.forEach((ele)=>{
        tableDonationSum+=Number(ele.totalAmount);
        console.log(tableDonationSum)
        tableServiceFeeSum+=Number(ele.serviceFee);
        console.log(tableServiceFeeSum)
        tabletotalRecurringAmount+=Number(ele.recurringAmount);

      })
      setTableDonationAmount({tableDonationSum,tableServiceFeeSum,tabletotalRecurringAmount})

    };
    
      getTransByOrgCause()
  }, [dateObj]);
console.log(totalRecurring)
console.log(totalDonations)
console.log(tableDonationAmount)
console.log(recurrByDate )
  // totalRecurring=recurrByDate;
  const toDonationReport = async (output) => {
    console.log(output);
      localStorage.setItem('causeId', output.causeId);
      navigate('/orgreport/donation');
  };
console.log(transByCause)
console.log(dateSearch)
  return (
    <div style={{ maxWidth: '100%' }} class='col-lg-12 pt-2'>
      <div class='row mb-3'>
        <h1 className='text-black p-3 display-6'>{organizationName}</h1>
        <div class='col-xl-3 col-md-6 col-lg-3 col-sm-6 py-2'>
          <div class='card text-white gradient1 h-100'>
            <div class='card-body '>
              <div class='rotate'>
                <i class='fa fa-user fa-4x'></i>
              </div>
              {/* <h6 class="text-uppercase text-white fw-bold">{t("Organizations")}</h6>
                        <h1 class="display-4 text-white ">{orgsList?orgsList.length:" "}</h1> */}
              <h6 class='text-uppercase text-white fw-bold'>{t('Causes')}</h6>
              <FontAwesomeIcon style={{ float: 'right' }} className='mr-2 fa-2xl' icon={faRibbon} />
              <h1 class='display-6 text-white '>{causeCount}</h1>
            </div>
          </div>
        </div>
        <div class='col-xl-3 col-lg-3 col-md-6 col-sm-6 py-2'>
          <div class='card text-white gradient2 h-100'>
            <div class='card-body'>
              <div class='rotate'>
                <i class='fab fa-twitter fa-4x'></i>
              </div>
              {/* <h6 class="text-uppercase text-white fw-bold">{t("Donors")}</h6>
                        <h1 class="display-4 text-white ">{donorCount?donorCount:" "}</h1> */}
              <h6 class='text-uppercase text-white fw-bold'>{t('Donations')}</h6>
              <div class='row'>
                <div class='col-lg-8 col-md-12 col-sm-12 mt-1' style={{ fontSize: '1.9rem' }}>
                  <h2 class='text-white'>${totalDonations&&totalRecurring > 0 ? (Number(totalRecurring?totalRecurring:0)+Number(totalDonations)).toString().slice(0, 7) : totalDonations}</h2>
                </div>
                <div class='col-lg-4 col-md-12 col-sm-12'>
                  <FontAwesomeIcon className='fa-2xl' icon={faHandHoldingDollar} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='col-xl-3 col-lg-6 col-md-6 col-sm-6 py-2'>
          <div class='card text-white gradient1 h-100'>
            <div class='card-body '>
              <div class='rotate'>
                <i class='fa fa-list fa-4x'></i>
              </div>
              {/* <h6 class="text-uppercase text-white fw-bold">{t("Users")}</h6>
                        <h1 class="display-4 text-white">{usersCount?usersCount:" "}</h1> */}
              <h6 class='text-uppercase text-white fw-bold'>{t('Donors')}</h6>
              <FontAwesomeIcon style={{ float: 'right' }} className='mr-2 fa-2xl' icon={faHandHoldingHeart} />
              <h1 class='display-6 text-white'>{donors}</h1>
            </div>
          </div>
        </div>

        <div class='col-xl-3 col-lg-6 col-md-6 col-sm-6 py-2'>
          <div class='card text-white gradient2 h-100'>
            <div class='card-body'>
              <div class='rotate'>
                <i class='fa fa-share fa-4x'></i>
              </div>
              {/* <h6 class="text-uppercase text-white fw-bold">{t("Shares")}</h6>
                        <h1 class="display-4 text-white">36</h1> */}
              <h6 class='text-uppercase text-white fw-bold'>{t('Upcoming events')}</h6>
              <FontAwesomeIcon style={{ float: 'right' }} className='mr-2 fa-2xl' icon={faCalendarDays} />
              <h1 class='display-6 text-white '>{eventCount < 10 ? '0' + eventCount : eventCount}</h1>
            </div>
          </div>
        </div>
      </div>

      <hr />
      <div class='row '>
        <div class='col-lg-11 col-md-6 col-sm-12 mt-3 ml-3'>
          <h3 class='mt-3 mb-3 text-secondary fs-3 fw-bold text-black'>{t('Cause Wise Donations (Settled)')}</h3>
          <div className='row'>
            <div className='col-lg-4'>
              <RangePicker onChange={onChange} defaultValue={defaultRange} format={dateFormat} />
            </div>
            <div className='col-lg-6 p-2'>
             {!dateSearch?<h4 className='fw-bold'>All Data</h4>:""} 
            </div>
          
          </div>
          <div class='row'>
            <div class='col-lg-11'>
              <div class='styled-table'>
                <table class='table'>
                  <thead class='thead-light'>
                    <tr>
                      <th>{t('Cause')}</th>
                      <th>{t('Donation')}</th>
                      <th>{t('Service Fee')}</th>
                      <th>{t('Recurring Amount')}</th>
                    </tr>
                  </thead>
                  <tbody class='text-black'>
                    {transByCause.length > 0 ? (
                      transByCause.map((output) => (
                        <>
                        <tr
                          key={output.causeId}
                          onClick={() => {
                            toDonationReport(output);
                          }}
                        >
                          {(Number(output.totalAmount)||Number(output.serviceFee)||Number(output.recurringAmount))>0? 
                          <>
                          <td>{output.cause}</td>
                          <td>$ {output.totalAmount?output.totalAmount:"0.00"}</td>
                          <td>$ {output.serviceFee ? (Number(output.serviceFee) <= 0.009 && Number(output.serviceFee) > 0 ? Number(output.serviceFee).toFixed(2) : Number(output.serviceFee).toFixed(2)) : '0.00' }</td>
                          <td>$ {output.recurringAmount ? (output.recurringAmount <= 0.009 && output.recurringAmount > 0 ? Number(output.recurringAmount).toFixed(2) : Number(output.recurringAmount).toFixed(2)) : '0.00' }</td>
                          </>
                          :""}
                        </tr>
                        </>
                      ))
                     
                    ) : (
                      <td colSpan='2' className='text-center'>
                        <h2>No Record Found</h2>
                      </td>
                    )}
                   {noRecordFound?"":<tr style={{borderTop:'2px solid #000', borderImage:"linear-gradient(#f6b73c, #4d9f0c) 30;"}}>
                       <td className='fw-bold fs-6'>Total</td>
                       <td className='fw-bold'>$ {tableDonationAmount?.tableDonationSum?.toFixed(2)}</td>
                       <td className='fw-bold'>$ {tableDonationAmount?.tableServiceFeeSum?.toFixed(2)}</td>
                       <td className='fw-bold'>$ {tableDonationAmount?.tabletotalRecurringAmount?.toFixed(2)}</td>
                    </tr>} 
                    {/* <LoadingOutlined style={{color:"#000",fontSize:"40px"}}/> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class='row'>
          {/* <div class='col-lg-11 col-md-6 col-sm-12 mt-3 ml-3'>
          <h3 class='mt-3 mb-3 text-secondary fs-3 fw-bold text-black'>{t('Cause Wise Donations (Un-Settled)')}</h3> */}
             <h3 class='mt-3 mb-3 text-secondary fs-3 fw-bold text-black'>{t('Cause Wise Donations (Un-Settled)')}</h3>
            <div class='col-lg-11'>
              <div class='styled-table'>
                <table class='table'>
                  <thead class='thead-light'>
                    <tr>
                      <th>{t('Cause')}</th>
                      <th>{t('Donation')}</th>
                      <th>{t('Service Fee')}</th>
                      {/* <th>{t('Recurring Amount')}</th> */}
                    </tr>
                  </thead>
                  <tbody class='text-black'>
                    {transByCauseApproved.length > 0 ? (
                      transByCauseApproved.map((output) => (
                        <>
                        <tr
                          key={output.causeId}
                          onClick={() => {
                            toDonationReport(output);
                          }}
                        >
                          {(Number(output.totalAmount)||Number(output.serviceFee))>0? 
                          <>
                          <td>{output.cause}</td>
                          <td>$ {output.totalAmount?output.totalAmount:"0.00"}</td>
                          <td>$ {output.serviceFee ? (Number(output.serviceFee) <= 0.009 && Number(output.serviceFee) > 0 ? Number(output.serviceFee).toFixed(4) : Number(output.serviceFee).toFixed(4)) : '0.00' }</td>
                          {/* <td>$ {output.recurringAmount ? (output.recurringAmount <= 0.009 && output.recurringAmount > 0 ? Number(output.recurringAmount).toFixed(4) : Number(output.recurringAmount).toFixed(2)) : '0.00' }</td> */}
                          </>
                          :""}
                        </tr>
                        </>
                      ))
                     
                    ) : (
                      <td colSpan='2' className='text-center'>
                        <h2>No Record Found</h2>
                      </td>
                    )}
                   {noRecordFound?"":<tr style={{borderTop:'2px solid #000', borderImage:"linear-gradient(#f6b73c, #4d9f0c) 30;"}}>
                       <td className='fw-bold fs-6'>Total</td>
                       <td className='fw-bold'>$ {tableDonationAmountApproved?.tableDonationSumApproved?.toFixed(2)}</td>
                       <td className='fw-bold'>$ {tableDonationAmountApproved?.tableServiceFeeSumApproved?.toFixed(2)}</td>
                       {/* <td className='fw-bold'>$ {tableDonationAmountApproved?.tabletotalRecurringAmountApproved?.toFixed(2)}</td> */}
                    </tr>} 
                    {/* <LoadingOutlined style={{color:"#000",fontSize:"40px"}}/> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        {/* </div> */}
          </div>
       
        <div class='col-lg-11 col-md-6 col-sm-12 mt-3 ml-3'>
          <h3 class='mt-3 mb-3 text-secondary fs-3 fw-bold text-black'>{t('Recent Donations')}</h3>

          <div class='row'>
            <div class='col-lg-11'>
              <div class='styled-table'>
                <table class='table'>
                  <thead class='thead-light'>
                    <tr>
                      {/* <th>{t('Organization')}</th> */}
                      <th>{t('Donation Date')}</th>
                      <th>{t('Cause')}</th>
                      <th>{t('Donation')}</th>
                      {/* <th>{t('Service Fee')}</th> */}
                      <th>{t('Donor Name')}</th>
                    </tr>
                  </thead>
                  <tbody class='text-black'>
                    {covertedTransObj.length > 0 ? (
                      covertedTransObj.slice(0, 6).map((output) => (
                        <tr key={output.organizationId}>
                          {/* <td>{output.organizationName}</td> */}
                          <td>{output.donationDate}</td>
                          <td>{output.cause}</td>
                          <td>{output.amount}</td>
                          {/* <td>$ {output.serviceFee ? output.serviceFee : 0}</td> */}

                          <td>
                            {output.firstName} {output.lastName}
                          </td>
                          {/* <td></td> */}
                        </tr>
                      ))
                    ) : (
                      <td colSpan='4' className='text-center'>
                        <h2>No Record Found</h2>
                      </td>
                    )}
                    {/* <LoadingOutlined style={{color:"#000",fontSize:"40px"}}/> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-lg-4 col-md-6 col-sm-12 col-sm-offset-5">
                <h4 className='title mt-6 mb-3 text-center text-white'>{t("Data in Chart")}</h4>
                 <div className="mb-5 ml-10 align-center" style={{height:"300px",width:"400px"}}><PieChart/> </div>
                 </div> */}
      </div>
    </div>
  );
};

export default OrgDashboard;
